@import 'styles/mixins';
@import 'styles/variables';

.container {
  :global .ant-modal-content {
    border-radius: 8px;
    @include shadow-3;
  }

  :global .ant-modal-body {
    padding: 0;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px;

  h2 {
    @include header-md;
    color: $almanac-black;
    margin: 0;
    flex: 1;
  }
}

.closeButton {
  display: flex;
  align-items: center;

  & svg {
    fill: $almanac-black;
  }
}

.body {
  @include body-md-text;
  color: $almanac-black;
  max-width: 560px;
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.footer {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}

.actionButton {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: $green-50;
  border: 1px solid $green-60;
  border-radius: 4px;
  @include shadow;
  @include btn-lg-text;
  color: $white;
}
